/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';

const Header = () => {
    const { hero } = useContext(PortfolioContext);
    const { title, name, subtitle, cta } = hero;

    const [isDesktop, setIsDesktop] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (window.innerWidth > 769) {
            setIsDesktop(true);
            setIsMobile(false);
        } else {
            setIsMobile(true);
            setIsDesktop(false);
        }
    }, []);

    return (
        <section id="hero" className="jumbotron">
            <Container>
                <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
                    <h1 className="hero-title">
                        {title || 'Hi, my name is'}{' '}
                        <span className="hero__name-color">{name || 'Your Name'}</span>
                        <br />
                        {subtitle || "I'm the Unknown Developer."}
                    </h1>
                </Fade>
                {/* <Fade bottom={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="3000px"> */}
                <p className="hero-cta">
                    <Link to="about" smooth duration={1000}>
                        <div className="scroll__wrapper">
                            <div className="scroll__container">
                                <div className="mouse"></div>
                                <p className="scroll">Scroll</p>
                            </div>
                        </div>
                    </Link>
                </p>
                {/* </Fade> */}
            </Container>
        </section>
    );
};

export default Header;
